import React from 'react';
import './ExperienceItem.css';

const ExperienceItem = ({ title, duration, description, papers, organization, location }) => {
	// Note: organization and location might need to be added to experiences.json if they don't exist, 
	// but I'll assume they might be part of the object or just use title if that's what's available.
	// Based on previous file, it just had title/duration/description/papers. 

	return (
		<div className="experience-card">
			<div className="experience-sidebar">
				<div className="experience-duration">{duration}</div>
			</div>

			<div className="experience-main">
				<h3 className="experience-title">{title}</h3>
				{/* If organization exists, show it, otherwise just title is fine */}
				{organization && <div className="experience-org">{organization}</div>}

				<div className="experience-description">
					<ul>
						{description.map((point, index) => (
							<li key={index}>{point}</li>
						))}
					</ul>
				</div>

				{papers && papers.length > 0 && (
					<div className="experience-papers">
						<h5 className="papers-heading">Key Papers</h5>
						<div className="papers-grid">
							{papers.map((paper, index) => (
								<div key={index} className="paper-mini-card">
									<div className="paper-mini-content">
										<a href={paper.arxivLink || paper.projectLink} target="_blank" rel="noopener noreferrer" className="paper-mini-title">
											{paper.title}
										</a>
										<span className="paper-mini-conf">{paper.conference}</span>
									</div>
								</div>
							))}
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default ExperienceItem;
